import React from 'react'
import { domToReact } from 'html-react-parser'

export const SurveyQuestion = props => {
  
  return <div 
    { ...props.attribs }
  >
    <div className="type">{ props.attribs['data-type'] }</div>
    { 
      domToReact(
        props.children, 
        { 
          replace: props.replace
        }
      )
    }
  </div>
}
